import BaseComponent from '../../../js/base-component';
import { Modal } from '../../../js/modal';

class CareProductsStepFive extends BaseComponent {
    constructor(element) {
        super(element);

        this.body = document.querySelector('body');
        this.day = this.element.querySelector('#day') || '';
        this.birthday = this.element.querySelector('#birthday') || '';
        this.caredegree = this.element.querySelector('#caredegree2') || '';
        this.modalCaredegree = this.element.querySelector('#modalCaredegree') || '';
        this.modalContent = `<div class="bold"></div><div></div>`;
        this.modalContainer = document.querySelector('#contentModal') || '';
        this.modal = new Modal( this.modalContainer );

        if (this.modalCaredegree) this.modalContent = `<div class="bold">${this.modalCaredegree.dataset.headline}</div><div>${this.modalCaredegree.dataset.content}</div>`;

        if ( this.day ) this.day.addEventListener('change', this.checkBirthday);

        if ( this.caredegree ) {
            this.caredegree.addEventListener('click', (evt) => {
                this.modal.handleModal('content','open', this.modalContent);
            });
        }

        this.checkBirthday();

        // set tabindex for mobile to day, month, year, salutaion
        if ( window.matchMedia('(max-width: 47.9375rem)').matches ) {
            this.element.querySelector('.u-care-products__field--day').setAttribute('tabindex','1');
            this.element.querySelector('.u-care-products__field--month').setAttribute('tabindex','2');
            this.element.querySelector('.u-care-products__field--year').setAttribute('tabindex','3');
            this.element.querySelector('.u-care-products__field--salutation').setAttribute('tabindex','4');
        }
    }

    onInit() {}

    checkBirthday = () => {
        if ( this.day.value == '') {
            this.birthday.classList.remove('hidden');
        } else {
            this.birthday.classList.add('hidden');
        }
    }
}

export default {
    name: 'CareProductsStepFive',
    definition: CareProductsStepFive
};